var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigTrainFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7.75024V17.5002C20.5 20.1524 21.5536 22.6959 23.4289 24.5713C25.3043 26.4467 27.8478 27.5002 30.5 27.5002C33.1522 27.5002 35.6957 26.4467 37.5711 24.5713C39.4464 22.6959 40.5 20.1524 40.5 17.5002V7.75024M23 37.5L20.5 35M38 37.5L40.5 35M20.5 47.5L15.5 55M40.5 47.5L45.5 55M23 47.5C16 47.5 10.5 42 10.5 35V25C10.5 19.6957 12.6071 14.6086 16.3579 10.8579C20.1086 7.10714 25.1957 5 30.5 5C35.8043 5 40.8914 7.10714 44.6421 10.8579C48.3929 14.6086 50.5 19.6957 50.5 25V35C50.5 42 45 47.5 38 47.5H23Z",
    stroke: "#4B286D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigTrainFront);
export default __webpack_public_path__ + "static/media/big-train-front.3239db1e4f7d035b7c16be489108d63b.svg";
export { ForwardRef as ReactComponent };